<template>
  <div :class="['irr-multi-monthly-date-picker multi-monthly-date-picker date-picker-mask',{'rollOut':openDatesPicker}]">
            <!--所选时段-->
            <div class="float-top" id="floatTop">
                <div>
                    <div class="flex flex-hcenter flex-vcenter txt-111 date-tit">
                        <div class="close-btn" @click="onCloseDatePicker"></div>
                        <p class="txt36">选择上课时间</p>
                        <span class="txt28 plr10" @click="onClearSelectedHandler">清除</span>
                    </div>
                    <div class="txt-center">
                        <div
                            class="time-tip">{{textTip()}}</div>
                    </div>
                    
                    <IrrSelectedTimes
                        v-if="irrSelectedTimeInfo"
                    ></IrrSelectedTimes>
                    
                </div>
            </div>

            <!--日历控件-->
            <div class="months">
              <IrrMonthlyDatePicker
                        v-for="monthInfo in monthList"
                        :key="monthInfo.year + '' + monthInfo.month"
                        :year="monthInfo.year"
                        :month="monthInfo.month"
                        :datesGroup="datesGroup"
                        :irrSelectedCourse="selectedDateGroupMap"
                        :groupLimit="groupLimit"
                        :rate="rate"
                        :curDate="curDate"
                        :curMonth = "curMonth"
                        @onCloseChoose="onCloseChoose"
                        @onDateChangeHandler="onDateChangeHandler"
                    >
                    </IrrMonthlyDatePicker>
            </div>
            <div class="bottom-btn">
                <a class="btn-submit" @click="onClickSaveHandler">保存</a>
            </div>
        </div>
</template>
<script>
import IrrMonthlyDatePicker from './IrrMonthlyDatePicker'
import IrrSelectedTimes from './IrrSelectTimes'
import { mapState } from 'vuex';
import _ from 'lodash'
export default {
  name: 'IrrMultiMonthlyDatePicker',
  props: {
    minSelectLimit: Number,
    groupLimit: Number,
    openDatesPicker: Boolean,
    startDate: String,
    endDate: String,
    rate: Number,
    datesGroup: Array
  },
  computed: mapState({
    irrSelectedTimeInfo: state => state.newsign.irrSelectedTimeInfo
  }),
  components: {
    IrrMonthlyDatePicker,
    IrrSelectedTimes
  },
  data(){
    return {
      irrSelectedCourse: [],
      selectedDateGroupMap: {},
      monthList: [],
      openCell: '',
      curDate: '',
      curMonth: 0
    }
  },
  watch: {
    irrSelectedTimeInfo(){
      var times  = _.flatten(_.values(this.irrSelectedTimeInfo));
      if (times.length > this.groupLimit){
          this.$store.dispatch('toast', {title: '课次已选满', show: true});
          return;
      }
    }
  },
  methods: {
    init (){
      var startDate = new Date(this.startDate.replace(/-/g, '/'));
      var endDate = new Date(this.endDate.replace(/-/g, '/'));
      //按月取日历
      var monthArray = this.getAllMonths(startDate, endDate);
      this.monthList = monthArray;
    },
    //获取时间段内的所有月份
    getAllMonths(startDate, endDate){
      var result = [];
      var startYear = startDate.getFullYear();
      var startMonth = startDate.getMonth();
      var endYear = endDate.getFullYear();
      var endMonth = endDate.getMonth();
      var mCount = 0;
      if (endYear - startYear > 0) {
        mCount = (endYear - startYear) * 12 + endMonth - startMonth + 1;
      } else {
        mCount = endMonth - startMonth + 1;
      }
      if (mCount > 0) {
        for (var i = 0; i < mCount; i++) {
          if (startMonth < 11) {
            result[i] = {year: startYear, month: startMonth};
            startMonth += 1;
          } else {
            result[i] = {year: startYear, month: startMonth};
            startMonth = 0;
            startYear += 1;
          }
        }
      }
      return result;
    },
    onCloseDatePicker(){
       this.$emit('onCloseDatePicker');
    },
      /**
     * 课次变更后，显示更新
     * groupLimit：选课最多限制次数
     * minSelectLimit：选课最少限制次数
     * */
    textTip(){
        var times  = _.flatten(_.values(this.irrSelectedTimeInfo));
        var len  = times.length;
        console.log(this.minSelectLimit, this.groupLimit);
        if (this.minSelectLimit < this.groupLimit) {
            if (len < this.minSelectLimit) {
                return `至少还需选${this.minSelectLimit - len}课次时间`;
            } else if (len >= this.minSelectLimit && len < this.groupLimit) {
                if (this.groupLimit > 100) {
                    return `已选择${len}课次时间`;
                } else {
                    return `还可以选${this.groupLimit - len}课次时间`;
                }
            } else if (len == this.groupLimit) {
                return `已选择${len}课次时间`;
            }
        } else if (this.minSelectLimit == this.groupLimit) {
            if (len < this.groupLimit) {
                return `还需选${this.groupLimit - len}课次时间` 
            } else if (len == this.minSelectLimit) {
            return `已选择${this.groupLimit}课次时间`;
          }
        }
    },
    onClickSaveHandler(){
        var times  = _.flatten(_.values(this.irrSelectedTimeInfo));
        var len  = times.length;
        var minSelectLimit = this.minSelectLimit;
        var groupLimit = this.groupLimit;
        console.log('非规律课选择信息：', this.irrSelectedTimeInfo);
        if (len == 0) {
            this.$store.dispatch('toast', {title: '请选择学习日期', show: true} );
            return;
        }
        if (len < minSelectLimit) {
            var n = minSelectLimit - len;
            if (minSelectLimit < groupLimit) {
                this.$store.dispatch('toast', {title: `至少还需选择${n}课次时间`, show: true} );
            } else if (minSelectLimit == groupLimit) {
                this.$store.dispatch('toast', {title: `还需选择${n}课次时间`, show: true} );
            }
            return;
        } else if (len > this.groupLimit) {
          this.$store.dispatch('toast', {title: '课次已选满', show: true});
          return;
      }
        this.$emit('onSaveDateGroupIdsHandler', this.irrSelectedTimeInfo);
    },
    onClearSelectedHandler(){
       var groupIds = _.keys(this.selectedDateGroupMap);
        var selectedMap = this.selectedDateGroupMap;
        groupIds.map(groupId => {
            delete selectedMap[groupId];
        });
        this.selectedDateGroupMap = selectedMap;
        this.curMonth = 0;
        this.$store.commit('updateIrrSelectedTimeInfo', {});
    },
    onDateChangeHandler(date){
        var selectedDateGroupMap = this.selectedDateGroupMap;
        var times  = _.flatten(_.values(this.irrSelectedTimeInfo));
        if (date.highlight) {
            if (selectedDateGroupMap[date.groupId]) {
                delete selectedDateGroupMap[date.groupId];
                this.selectedDateGroupMap = selectedDateGroupMap;
                this.curDate = date.tempFmt;
                this.curMonth = date.month;
            } else if (this.groupLimit == 1) {
                this.onClearSelectedHandler();
                selectedDateGroupMap[date.groupId] = date;
                this.selectedDateGroupMap = selectedDateGroupMap;
                this.curDate = date.tempFmt;
                this.curMonth = date.month;
            } else if (times.length <= this.groupLimit) {
                selectedDateGroupMap[date.groupId] = date;
                this.selectedDateGroupMap = selectedDateGroupMap;
                this.curDate = date.tempFmt;
                this.curMonth = date.month;
            } else {
                this.$store.dispatch('toast', {title: '超出选择数限制', show: true});
                return;
            }
        }
    },
    onCloseChoose(){

    }
  },
  mounted(){
    this.init();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/IrrMultiMonthlyDatePicker.vue